<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.outerCartonInspection_PhotoLabels"
      >
        <span
          class="col-form-label"
        >Photograph labels and sealing tape if they exhibit damage, tampering or nonconformance</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.outerCartonInspection_OuterSealingTape"
      >
        <span class="col-form-label">Inspect sealing tapes</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.outerCartonInspection_InspectLabels"
      >
        <span class="col-form-label">Inspect labels and verify data</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.outerCartonInspection_ReadableBarcode"
      >
        <span class="col-form-label">Scan barcode to verify information is readable</span>
      </b-form-radio-group>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'ideaOuterProductCarton',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        outerCartonInspection_PhotoLabels: this.inspectionDetails[FIELDS.OUTER_CARTON_INSPECTION__PHOTO_LABELS] || '',
        outerCartonInspection_OuterSealingTape: this.inspectionDetails[FIELDS.OUTER_CARTON_INSPECTION__OUTER_SEALING_TAPE] || '',
        outerCartonInspection_InspectLabels: this.inspectionDetails[FIELDS.OUTER_CARTON_INSPECTION__INSPECT_LABELS] || '',
        outerCartonInspection_ReadableBarcode: this.inspectionDetails[FIELDS.OUTER_CARTON_INSPECTION__READABLE_BARCODE] || '',
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>